import React from 'react'
import { SocialButton } from './SocialButton'
import { useGoogleLogin } from '@react-oauth/google'
import { Google } from 'app/assets/icons'
import { colors } from 'shared/assets/styles'
import Axios from 'axios'
import { authType } from 'shared/utils'
import type { LoginForm } from 'shared/types'

type GoogleSignInButtonProps = {
    connect: (data: LoginForm) => Promise<void>
}

export const GoogleSignInButton = ({ connect }: GoogleSignInButtonProps) => {
    const login = useGoogleLogin({
        onSuccess: async tokenResponse => {
            const { data: profile } = await Axios.get(
                `https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=${tokenResponse.access_token}`,
                {
                    headers: {
                        Authorization: `Bearer ${tokenResponse.access_token}`
                    }
                }
            )

            if (profile) {
                const { email, id } = profile
                const data = {
                    login: email,
                    loginType: authType.GOOGLE,
                    stayLoggedIn: true,
                    uid: id,
                    accessToken: tokenResponse.access_token
                }
                connect(data)
            }
        }
    })

    return (
        <SocialButton
            handleClick={() => login()}
            background={colors.google}
            labelKey="social.google.button"
            icon={<Google />}
        />
    )
}
